import { PureComponent, ReactNode } from 'react';
import { AntTooltip } from '../../../../common/AntTooltip';

interface Props {
    tooth: string;
    firstSurfaceName: string;
    secondSurfaceName: string;
    thirdSurfaceName: string;
    fourthSurfaceName: string;
    fifthSurfaceName: string;
    isFirstSurfaceSelected: boolean;
    isSecondSurfaceSelected: boolean;
    isThirdSurfaceSelected: boolean;
    isFourthSurfaceSelected: boolean;
    isFifthSurfaceSelected: boolean;
    selectSurface: (teeth: string, surface: number) => void;
}

class RestSurfaces extends PureComponent<Props> {
    render(): ReactNode {
        const {
            tooth,
            firstSurfaceName,
            secondSurfaceName,
            thirdSurfaceName,
            fourthSurfaceName,
            fifthSurfaceName,
            selectSurface,
            isFirstSurfaceSelected,
            isSecondSurfaceSelected,
            isThirdSurfaceSelected,
            isFourthSurfaceSelected,
            isFifthSurfaceSelected,
        } = this.props;

        return (
            <svg
                className="max-w-40 max-h-40 cursor-pointer"
                viewBox="0 0 39 38"
                xmlns="http://www.w3.org/2000/svg"
                style={{ transform: 'rotate(45deg)' }}
            >
                <AntTooltip content={fourthSurfaceName} placement="right" mouseEnterDelay={0.5}>
                    <path
                        d="M1.5 19C1.5 9.05888 9.55888 1 19.5 1V19H1.5Z"
                        fill={isFourthSurfaceSelected ? '#D1EDE1' : '#F4F4F4'}
                        stroke={isFourthSurfaceSelected ? '#19A66A' : '#BABABA'}
                        stroke-width="1.28571"
                        onClick={() => selectSurface(tooth, 4)}
                    />
                </AntTooltip>
                <AntTooltip content={firstSurfaceName} placement="right" mouseEnterDelay={0.5}>
                    <path
                        d="M19.5 1C29.4411 1 37.5 9.05888 37.5 19H19.5V1Z"
                        fill={isFirstSurfaceSelected ? '#D1EDE1' : '#F4F4F4'}
                        stroke={isFirstSurfaceSelected ? '#19A66A' : '#BABABA'}
                        stroke-width="1.28571"
                        onClick={() => selectSurface(tooth, 1)}
                    />
                </AntTooltip>
                <AntTooltip content={secondSurfaceName} placement="bottom" mouseEnterDelay={0.5}>
                    <path
                        d="M19.5 19H37.5C37.5 28.9411 29.4411 37 19.5 37V19Z"
                        fill={isSecondSurfaceSelected ? '#D1EDE1' : '#F4F4F4'}
                        stroke={isSecondSurfaceSelected ? '#19A66A' : '#BABABA'}
                        stroke-width="1.28571"
                        onClick={() => selectSurface(tooth, 2)}
                    />
                </AntTooltip>
                <AntTooltip content={thirdSurfaceName} placement="left" mouseEnterDelay={0.5}>
                    <path
                        d="M1.5 19H19.5V37C9.55888 37 1.5 28.9411 1.5 19Z"
                        fill={isThirdSurfaceSelected ? '#D1EDE1' : '#F4F4F4'}
                        stroke={isThirdSurfaceSelected ? '#19A66A' : '#BABABA'}
                        stroke-width="1.28571"
                        onClick={() => selectSurface(tooth, 3)}
                    />
                </AntTooltip>
                <AntTooltip content={fifthSurfaceName} placement="right" mouseEnterDelay={0.5}>
                    <circle
                        cx="19.5"
                        cy="19"
                        r="9"
                        fill={isFifthSurfaceSelected ? '#D1EDE1' : '#F4F4F4'}
                        stroke={isFifthSurfaceSelected ? '#19A66A' : '#BABABA'}
                        stroke-width="1.28571"
                        onClick={() => selectSurface(tooth, 5)}
                    />
                </AntTooltip>
            </svg>
        );
    }
}

export default RestSurfaces;
